module.exports = __webpack_public_path__ + "img/bone.jpg";